import React, { useState } from "react";
import { PersonalDataContext as Context } from "./index";

import { createContactPersonalDataApi } from "../Api/CreateContact.js";
import { updateContactPersonalDataApi } from "../Api/UpdateContact.js";
import { showContactPersonalDataApi } from "../Api/ShowContact.js";
import {
  alertToastErrorFromResponse,
  getErrorsArrayMessageFromHtttpResponse,
} from "../../../Shared/Utils/errorUtils.js";
import { alertError } from "../../../Shared/Utils/alertMessages.js";

const PersonalDataProvider = (props) => {
  const [apiErrors, setApiErrors] = useState([]);
  const [item, setItem] = useState([]);
  const [loading, setLoading] = useState(false);

  //get all item data
  const getItem = async (id) => {
    setLoading(true);
    try {
      let response = await showContactPersonalDataApi(id);

      let data = response.data;
      if (response.result === "success") {
        setItem(data);
      } else {
        setItem({});
        alertToastErrorFromResponse(
          "Error obteniendo datos del contacto",
          response
        );
      }
    } catch (error) {
      alertError("Error desconocido obteniendo datos del contacto !");
    } finally {
      setLoading(false);
    }
  };

  //Create object
  const createItem = async (data) => {
    let response = await createContactPersonalDataApi(data);

    if (response?.result && response?.result == "success") {
      setApiErrors([]);
      setItem(response.data);
    } else {
      setApiErrors(getErrorsArrayMessageFromHtttpResponse(response));
    }
  };

  //edit item
  const updateItem = async (data, id) => {
    let response = await updateContactPersonalDataApi(data, id);

    if (response?.result && response?.result == "success") {
      // setSuccessUpdated(true);
      setApiErrors([]);
    } else {
      setApiErrors(getErrorsArrayMessageFromHtttpResponse(response));
    }
  };

  const handleEdit = async (row) => {
    let editObject = tableData.find((e) => e.id === row.id);
    setItem(editObject);
    setApiErrors([]);
  };

  return (
    <Context.Provider
      value={{
        ...props,

        createItem,
        updateItem,
        setLoading,
        apiErrors,
        setItem,
        item,
        loading,
        handleEdit,
        getItem,
        setApiErrors,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default PersonalDataProvider;
